import humps from 'humps';
import { toastr } from 'react-redux-toastr';
import _get from 'lodash/get';
import * as fetchUtils from 'app/utils/FetchUtils';
import { addDownloadDetails } from 'app/utils/TransactionUtils.tsx';
import { createLoadingSelector } from 'app/reducers/loading';
import { PRODUCT_KEYS, TRANSACTION_STATE } from 'app/constants/Constants';
import { PRODUCT_RELEASE_CLICK } from 'app/constants/AmplitudeActions';
import { EventTypes } from 'app/utils/reduxAmplitude';

const createActionName = (name) => `app/admin/cp/${name}`;

export const TRANSACTION_CP_REQUEST = createActionName('TRANSACTION_CP_REQUEST');
export const TRANSACTION_CP_SUCCESS = createActionName('TRANSACTION_CP_SUCCESS');
export const TRANSACTION_CP_FAILURE = createActionName('TRANSACTION_CP_FAILURE');

export const CP_UPLOAD_REQUEST = createActionName('CP_UPLOAD_REQUEST');
export const CP_UPLOAD_SUCCESS = createActionName('CP_UPLOAD_SUCCESS');
export const CP_UPLOAD_FAILURE = createActionName('CP_UPLOAD_FAILURE');
export const CP_BIDS_SUCCESS = createActionName('CP_BIDS_SUCCESS');
export const CP_GET_EXEC_DOCS_SUCCESS = createActionName('CP_GET_EXEC_DOCS_SUCCESS');

export const ADHOC_CREATE_REQUEST = createActionName('ADHOC_CREATE_REQUEST');
export const ADHOC_CREATE_SUCCESS = createActionName('ADHOC_CREATE_SUCCESS');
export const ADHOC_CREATE_FAILURE = createActionName('ADHOC_CREATE_FAILURE');

export const ADHOC_UPDATE_REQUEST = createActionName('ADHOC_UPDATE_REQUEST');
export const ADHOC_UPDATE_SUCCESS = createActionName('ADHOC_UPDATE_SUCCESS');
export const ADHOC_UPDATE_FAILURE = createActionName('ADHOC_UPDATE_FAILURE');

export const PLACEHOLDER_REMOVE_REQUEST = createActionName('PLACEHOLDER_REMOVE_REQUEST');
export const PLACEHOLDER_REMOVE_SUCCESS = createActionName('PLACEHOLDER_REMOVE_SUCCESS');
export const PLACEHOLDER_REMOVE_FAILURE = createActionName('PLACEHOLDER_REMOVE_FAILURE');

const initialState = {};

export const adhocDocLoading = createLoadingSelector([createActionName('ADHOC_CREATE')]);
export const adhocDocUpdating = createLoadingSelector([createActionName('ADHOC_UPDATE')]);
export const isCPLoading = createLoadingSelector([createActionName('TRANSACTION_CP')]);

export default function details(state = initialState, action) {
    switch (action.type) {
        case TRANSACTION_CP_SUCCESS:
            return {
                ...state,
                ...action.data,
                documents: addDownloadDetails(_get(action, 'data')),
            };
        case CP_GET_EXEC_DOCS_SUCCESS:
            return {
                ...state,
                execDocs: action.data.execDocs,
                otherDocs: action.data.others,
            };
        default:
            return state;
    }
}

function unMapCP(data) {
    let prcessData = {};
    const ratingAgencyIds = [];
    const ipaIds = [];

    if (data.ratingAgencyIds) ratingAgencyIds.push(data.ratingAgencyIds);
    if (data.ipaIds) ipaIds.push(data.ipaIds);

    prcessData = {
        issuanceSize: data.issuanceSize * 10000000,
        discount: data.discount,
        issue_date: data.issueDate,
        tenor: data.tenor,
        rating: (data.rating && data.rating.value) || '',
        ratingAgencyIds,
        ipaIds,
        security_type: data.securityType,
    };

    return humps.decamelizeKeys(prcessData);
}

function mapCP(data) {
    let ratingAgency = {};
    let ipas = {};
    let investors = {};
    let acceptedInvestors;
    if (data.rating_agencies && data.rating_agencies.length !== 0) {
        ratingAgency = data.rating_agencies
            .map((m) => ({
                value: m.id,
                label: m.name,
            }))
            .reduce((r) => r);
    }
    if (data.ipas && data.ipas.length !== 0) {
        ipas = data.ipas
            .map((m) => ({
                value: m.id,
                label: m.name,
            }))
            .reduce((r) => r);
    }
    if (data.investors.length > 0) {
        investors = data.investors
            .map((m) => ({
                value: m.id,
                label: m.name,
            }))
            .reduce((r) => r);
    }
    if (data.accepted_investors.length > 0) {
        acceptedInvestors = data.accepted_investors.map((m) => ({
            value: m.id,
            label: m.name,
        }));
    }

    const prcessData = {
        ...data,
        clientId: data.customerId || (Array.isArray(data.customer) && data.customer.length > 0 && data.customer[0].id) || '',
        issuanceSize: data.issuance_size / 10000000,
        ratingAgencyIds: ratingAgency,
        acceptedInvestors,
        investorsIds: investors,
        ipa: data.ipas && data.ipas.length > 0 ? { valid: true } : { valid: false },
        rating: data.rating
            ? {
                  valid: true,
                  value: data.rating,
              }
            : { valid: false },
        ipaIds: ipas,
        securityType: data.security_type,
    };
    return humps.camelizeKeys(prcessData);
}

export function getCP(id) {
    return (dispatch) => {
        dispatch({ type: TRANSACTION_CP_REQUEST });
        return fetchUtils
            .getJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${id}`)
            .then((d) => mapCP(d))
            .then((d) => dispatch({ type: TRANSACTION_CP_SUCCESS, data: d, id }))
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    dispatch({ type: TRANSACTION_CP_FAILURE });
                    toastr.error('Error retrieving CP data', m);
                }),
            );
    };
}

export function updateCP(id, data) {
    return (dispatch) => {
        const payload = unMapCP(data);
        dispatch({ type: TRANSACTION_CP_REQUEST });
        return fetchUtils
            .putJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${id}`, {
                commercial_paper_transaction: payload,
            })
            .then((d) => mapCP(d))
            .then((d) => {
                toastr.success('Success!', 'CP data updated.');
                dispatch({ type: TRANSACTION_CP_SUCCESS, data: d, id });
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating CP data', m);
                }),
            );
    };
}

export function updateCPState(id, data) {
    return (dispatch) => {
        dispatch({ type: TRANSACTION_CP_REQUEST });
        return fetchUtils
            .putJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${id}`, {
                commercial_paper_transaction: data,
            })
            .then((d) => mapCP(d))
            .then((d) => {
                toastr.success('Success!', 'CP State Updated.');
                dispatch({ type: TRANSACTION_CP_SUCCESS, data: d, id });
                if (_get(data, 'transaction_state') === TRANSACTION_STATE.RELEASED) {
                    dispatch({
                        type: PRODUCT_RELEASE_CLICK,
                        meta: {
                            amplitude: [
                                {
                                    eventType: EventTypes.track,
                                    eventPayload: {
                                        eventName: PRODUCT_RELEASE_CLICK,
                                        transactionId: id,
                                        transaction_type: PRODUCT_KEYS.commercial_paper,
                                        ...data,
                                    },
                                },
                            ],
                        },
                    });
                }
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    dispatch({ type: TRANSACTION_CP_FAILURE });
                    toastr.error('Error updating CP State', m);
                }),
            );
    };
}

export function uploadCPDocuments(id, file, fileType) {
    return (dispatch) => {
        const body = new FormData();
        body.append('document', file);
        body.append('document_type', fileType);
        return fetchUtils
            .postFormData(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${id}/deal_documents`, body)
            .then(() => {
                dispatch(getCP(id));
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error uploading pool file', m);
                    throw new Error(m);
                }),
            );
    };
}

export function destroyFile(fileId, transId) {
    return (dispatch) =>
        fetchUtils
            .deleteJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${transId}/deal_documents/${fileId}`)
            .then(() => {
                toastr.success('File Destroyed');
                dispatch(getCP(transId));
            })
            .catch((ex) => {
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error destroying transaction file', m);
                });
            });
}

export function editDealName(transId, values) {
    return (dispatch) =>
        fetchUtils
            .putJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${transId}`, {
                commercial_paper_transaction: {
                    ...humps.decamelizeKeys(values),
                    id: transId,
                },
            })
            .then((d) => humps.camelizeKeys(d))
            .then((d) => {
                dispatch({ type: TRANSACTION_CP_SUCCESS, data: d, id: transId });
                toastr.success('Success!', 'Deal Name updated successfully');
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating deal name', m);
                }),
            );
}

export function generateDocs(transId) {
    toastr.success('Success!', 'Documents generation Request initiated');
    return (dispatch) =>
        fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${transId}/generate_documents`, {
                term_loan_transaction: {},
            })
            .then((d) => humps.camelizeKeys(d))
            .then((d) => {
                dispatch({
                    type: TRANSACTION_CP_SUCCESS,
                    data: d,
                    id: transId,
                });
            })
            .then(() => dispatch(pollingCPDocs(transId)))
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error Generating Documents', m);
                }),
            );
}

export function getCPExecDocs(id) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${id}/executable_documents`)
            .then((d) => humps.camelizeKeys(d))
            .then((d) => {
                const docs = _get(d, 'documents', []).filter((doc) => doc.files.length > 0);
                const others = d.otherFiles;
                const isGenerated = docs.every((item) => item.files[0].state === 'generated');
                const isFailed = docs.some((item) => item.files[0].state === 'failed');
                if (_get(d, 'errorMessage')) {
                    return _get(d, 'errorMessage');
                }
                if (!docs.length && others.length) {
                    dispatch({ type: CP_GET_EXEC_DOCS_SUCCESS, data: { execDocs: docs, others: d.otherFiles }, id });
                    return null;
                }
                if (isFailed) {
                    return docs;
                } else if (isGenerated) {
                    dispatch({ type: CP_GET_EXEC_DOCS_SUCCESS, data: { execDocs: docs, others: d.otherFiles }, id });
                    return docs;
                }
                return null;
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error fetching executable documents', m);
                }),
            );
}

export function pollCPExecDocs(id) {
    return (dispatch) =>
        fetchUtils
            .poll(() => dispatch(getCPExecDocs(id)), 180000, 3000)
            .then((d) => {
                if (!Array.isArray(d)) {
                    toastr.error('Error Finalizing Documents', d);
                } else if (!d.length) {
                    toastr.error('Error Finalizing Documents', 'Failed to generate executed documents');
                } else if (d.some((item) => item.files[0].state === 'failed')) {
                    toastr.error(
                        'Error Finalizing Documents',
                        `Please check the format of ${humps.pascalize(d.find((item) => item.files[0].state === 'failed').files[0].type)}`,
                    );
                } else {
                    toastr.success('Success!', 'Documents generated successfully.');
                }
            })
            .catch((e) => {
                const errMsg = (e && e.message) || 'Something went wrong, please try again after sometime';
                if (errMsg === 'timeout') {
                    toastr.error('Timeout Generating Documents', 'Please try again after sometime.');
                } else {
                    toastr.error('Error Generating Documents', errMsg);
                }
            });
}

export function generateExecDocs(transId, setSubmitting) {
    toastr.success('Success!', 'Documents generation Request initiated');
    return (dispatch) =>
        fetchUtils
            .postJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${transId}/executable_documents`, {
                term_loan_transaction: {},
            })
            .then(() => dispatch(pollCPExecDocs(transId)))
            .then(() => setSubmitting(false))
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error Generating Documents', m);
                }),
            );
}

export function revokeExecDocs(id) {
    return (dispatch) =>
        fetchUtils
            .postJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${id}/executable_documents/revoke`)
            .then((d) => {
                if (_get(d, 'success')) {
                    dispatch(getCPExecDocs(id));
                } else {
                    toastr.error('Failed to revoke executable documents');
                }
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error revoking executable documents', m);
                }),
            );
}

export function pollingCPDocs(id) {
    return (dispatch) =>
        fetchUtils
            .poll(() => dispatch(getCPDocs(id)), 180000, 1000)
            .then((d) => {
                dispatch({ type: TRANSACTION_CP_SUCCESS, data: d, id });
                toastr.success('Success!', 'Documents generated successfully.');
            })
            .catch((e) => {
                const errMsg = (e && e.message) || 'Something went wrong, please try again after sometime';
                if (errMsg === 'timeout') {
                    toastr.error('Timeout Generating Documents', 'Please try again after sometime.');
                } else {
                    toastr.error('Error Generating Documents', errMsg);
                }
            });
}

function getCPDocs(id) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${id}`)
            .then((d) => mapCP(d))
            .then((d) => {
                const docs = _get(d, 'documents', []).filter((doc) => doc.files.length > 0);
                const isGenerated = docs.every((item) => item.files[0].state === 'generated' || item.files[0].state === 'uploaded');
                if (isGenerated) return d;
                dispatch({ type: TRANSACTION_CP_SUCCESS, data: d, id });
                return null;
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating deal name', m);
                }),
            );
}

const formatAdHocData = (values) => {
    const data = {
        document: values,
    };
    return humps.decamelizeKeys(data);
};

export function addAdhocDocument(transId, data) {
    return (dispatch) => {
        dispatch({ type: ADHOC_CREATE_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${transId}/add_document`, formatAdHocData(data))
            .then(() => {
                dispatch({ type: ADHOC_CREATE_SUCCESS });
                dispatch(getCP(transId));
                toastr.success('Success!', 'Adhoc document has been created successfully');
            })
            .catch((ex) => {
                dispatch({ type: ADHOC_CREATE_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error adding document', m);
                });
            });
    };
}

export function updateAdhocDocument(transId, data) {
    return (dispatch) => {
        dispatch({ type: ADHOC_UPDATE_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${transId}/modify_document`, humps.decamelizeKeys(data))
            .then(() => {
                dispatch({ type: ADHOC_UPDATE_SUCCESS });
                dispatch(getCP(transId));
                toastr.success('Success!', 'Document settings has been updated successfully');
            })
            .catch((ex) => {
                dispatch({ type: ADHOC_UPDATE_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating settings', m);
                });
            });
    };
}

export function removeDocPlaceholder(transId, data) {
    return (dispatch) => {
        dispatch({ type: PLACEHOLDER_REMOVE_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/commercial_papers/${transId}/remove_document`, humps.decamelizeKeys(data))
            .then(() => {
                dispatch({ type: PLACEHOLDER_REMOVE_SUCCESS });
                dispatch(getCP(transId));
                toastr.success('Success!', 'Document placeholder has been removed successfully');
            })
            .catch((ex) => {
                dispatch({ type: PLACEHOLDER_REMOVE_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error removing placeholder', m);
                });
            });
    };
}
